// extracted by mini-css-extract-plugin
export default {"ModalOtpContainer":"ModalOtpVerification_ModalOtpContainer__gQm9R","ModalOtpTitle":"ModalOtpVerification_ModalOtpTitle__KwIEW"};